/* =====================================================================
   ms-bergfuehrer.js
   Die Bergfuehrer-Kacheln: Mischen, Filtern, Vorwahl im Anfrageformular.
   Fuer die Liste auf /pages/bergfuehrer (sections/ms-bergfuehrer.liquid)
   und den Ausschnitt auf der Startseite (sections/ms-home.liquid).

   UMGEBAUT AM 19.09.2026 (Auftrag C, GEO-Liste Guenther Punkt 1). Bis
   dahin holte diese Datei die Profile per fetch aus Supabase und baute
   die Kacheln im Browser; ohne JavaScript standen beide Seiten mit
   "Die Bergfuehrer werden geladen" da, und im ausgelieferten HTML gab
   es keinen einzigen Namen (gemessen 19.09.2026, 16:12). Seit dem
   19.09.2026 rendert Liquid die Kacheln aus den Metaobjekten
   bergfuehrer (snippets/ms-bergfuehrer-karte.liquid); diese Datei
   ruehrt nur noch an, was ohne Skript nicht geht:

   1. MISCHEN. Bei jedem Aufruf neu, Fisher und Yates (Alex, 09.09.2026:
      "damit es fair gegenueber allen ist und jeder mal an vorderer
      Stelle und hinterer steht"; warum nicht sort(zufall): die
      Vergleichsfunktion ist nicht konsistent, die vorderen Plaetze
      bleiben messbar oefter bei denen, die schon vorn standen). Im HTML
      stehen die Kacheln nach reihenfolge und Name, so sieht sie ein
      Crawler. Auf der Startseite (data-limit="3") stehen alle Kacheln im
      HTML, die ab der vierten mit hidden; nach dem Mischen sind die
      ersten drei sichtbar, der Rest versteckt. Ohne Skript: die ersten
      drei nach Reihenfolge.
   2. FILTERN. Die Auswahlfelder stehen mit ihren Optionen im HTML; die
      Regel, ab vier Kacheln und nur mit einem Feld, das wirklich trennt
      (06.09.2026: alle Aktivitaetsoptionen trafen 9 von 9, die Leiste
      haette ein Mengenproblem vorgetaeuscht), rechnet seit dem 20.09.2026
      schon Liquid (sections/ms-bergfuehrer.liquid, QA tempo#3: die per
      Skript eingeblendete Leiste schob das Raster um 127 Pixel, CLS
      0,1013). Das Skript rechnet sie hier noch einmal und kommt zum
      selben Ergebnis; es aendert damit nichts am Bild, es wendet nur die
      Auswahl an.
   3. VORWAHL. ?bergfuehrer=<kennung> (alte Verweise, Startseite) oeffnet
      den Aufklapper der Kachel, scrollt hin und waehlt den Bergfuehrer
      im Formular (sections/ms-bergfuehrer-anfrage.liquid) vor. Der Knopf
      "Anfrage schreiben" in einer Kachel waehlt ebenso vor; der Anker
      des Knopfs scrollt selbst zum Formular.

   Was ohne diese Datei schiefginge: nichts, was ein Gast nicht mit der
   Hand nachholen koennte. Die Reihenfolge waere fest, die Filterleiste
   bliebe verborgen, im Formular waehlte der Gast den Bergfuehrer selbst.

   ZUSTAND FUER MESSUNGEN
   ----------------------
   data-ms-stand an der Wurzel setzt Liquid (Zahl der Kacheln oder
   'leer'); das Skript ruehrt es nicht an. Keine HTML-Kommentare zum
   Messen, Shopify entfernt sie.
   ===================================================================== */
(function () {

  function mischen(feld) {
    for (var i = feld.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = feld[i]; feld[i] = feld[j]; feld[j] = t;
    }
    return feld;
  }

  function vorwaehlen(uuid, kennung) {
    var sel = document.querySelector('[data-bf-auswahl]');
    if (!sel) return false;
    var opt = null;
    for (var i = 0; i < sel.options.length; i++) {
      var o = sel.options[i];
      if ((uuid && o.value === uuid) || (kennung && o.getAttribute('data-kennung') === kennung)) { opt = o; break; }
    }
    if (!opt) return false;
    sel.value = opt.value;
    /* change ausloesen, damit das Formularskript den Namen in die
       Einwilligung setzt; laeuft es erst spaeter, liest es den Wert beim
       Binden selbst (namenSetzen beim Start). */
    var ev;
    try { ev = new Event('change', { bubbles: true }); } catch (e) { ev = document.createEvent('Event'); ev.initEvent('change', true, true); }
    sel.dispatchEvent(ev);
    return true;
  }

  function init(root) {
    if (!root || root.dataset.bfReady === '1') return;
    root.dataset.bfReady = '1';

    var grid = root.querySelector('[data-bf-grid]') || root;
    var karten = Array.prototype.slice.call(grid.querySelectorAll('[data-bf-item]'));
    if (!karten.length) return;

    var limit = parseInt(root.getAttribute('data-limit') || '0', 10);
    if (!(limit > 0)) limit = 0;

    /* 1. Mischen: Knoten in neuer Reihenfolge anhaengen.
       22.09.2026: auf /pages/bergfuehrer mischt schon das Skript direkt
       unter dem Raster (sections/ms-bergfuehrer.liquid, vor dem ersten
       Zeichnen, damit das vordere Foto sofort laedt) und setzt
       data-bf-gemischt. Dann bleibt die Reihenfolge, wie sie ist; die
       Schleife unten haengt die Knoten in derselben Folge wieder an und
       aendert damit nichts. */
    if (grid.getAttribute('data-bf-gemischt') !== '1') mischen(karten);
    for (var k = 0; k < karten.length; k++) {
      grid.appendChild(karten[k]);
      if (limit) karten[k].hidden = k >= limit;
      /* 20.09.2026 (QA tempo#3): Liquid gibt den ersten drei Kacheln der
         Liste loading="eager" (Kopf des Snippets ms-bergfuehrer-karte).
         Nach dem Mischen stehen andere vorn; die drei, die jetzt vorn
         stehen, bekommen eager, damit der Browser ihre Fotos nicht erst
         beim Rollen holt, und die erste fetchpriority high. Nur auf der
         Liste (ohne limit): auf der Startseite liegt das Band unter der
         Falz, dort bleibt alles lazy. Ein Bild, das schon laedt, stoert
         die Aenderung nicht.

         22.09.2026: auf /pages/bergfuehrer macht das inzwischen schon das
         Skript unter dem Raster, und zwar 1,3 s frueher (Zahlen im
         Kommentar dort). Diese Zeilen sind seitdem der Rueckfall fuer den
         Fall, dass jenes Skript nicht gelaufen ist, und laufen sonst ins
         Leere: sie setzen dieselben Werte noch einmal. Sie bleiben
         trotzdem stehen, weil sonst ein blockiertes Inline-Skript die
         Fotos ohne jede Vorfahrt liesse. Wer eines von beiden aendert,
         aendert beide. */
      if (!limit) {
        var bild = karten[k].querySelector('img.gc-img');
        if (bild) {
          bild.loading = k < 3 ? 'eager' : 'lazy';
          if (k === 0) bild.setAttribute('fetchpriority', 'high');
          else bild.removeAttribute('fetchpriority');
        }
      }
    }

    /* 2. Filtern, nur wo es eine Leiste gibt (Liste). */
    var bar = root.querySelector('[data-bf-bar]');
    var selects = root.querySelectorAll('[data-bf-filter]');
    var counter = root.querySelector('[data-bf-count]');
    var resetBtn = root.querySelector('[data-bf-reset]');
    var filterLeer = root.querySelector('[data-bf-filter-leer]');

    function matches(card, key, value) {
      if (!value) return true;
      return (card.getAttribute('data-' + key) || '').indexOf('|' + value + '|') !== -1;
    }

    if (bar && selects.length) {
      var wirksam = 0;
      for (var s = 0; s < selects.length; s++) {
        var sel = selects[s];
        var key = sel.getAttribute('data-bf-filter');
        var trennt = false;
        for (var o = 1; o < sel.options.length && !trennt; o++) {
          var n = 0;
          for (var c = 0; c < karten.length; c++) if (matches(karten[c], key, sel.options[o].value)) n++;
          if (n < karten.length) trennt = true;
        }
        var feld = sel.closest ? (sel.closest('label') || sel) : sel;
        feld.hidden = !trennt;
        if (trennt) wirksam++;
      }
      bar.hidden = !(karten.length >= 4 && wirksam > 0);

      var apply = function () {
        var chosen = {};
        for (var i = 0; i < selects.length; i++) chosen[selects[i].getAttribute('data-bf-filter')] = selects[i].value;
        var visible = 0;
        for (var c = 0; c < karten.length; c++) {
          var ok = matches(karten[c], 'act', chosen.act) && matches(karten[c], 'lang', chosen.lang);
          karten[c].style.display = ok ? '' : 'none';
          if (ok) visible++;
        }
        if (filterLeer) filterLeer.hidden = visible !== 0;
        if (counter) {
          var label = root.getAttribute('data-t-count') || '';
          var one = root.getAttribute('data-t-count-one');
          counter.textContent = visible + ' ' + (visible === 1 && one ? one : label);
        }
        if (resetBtn) resetBtn.hidden = !chosen.act && !chosen.lang;
      };
      for (var i = 0; i < selects.length; i++) selects[i].addEventListener('change', apply);
      if (resetBtn) resetBtn.addEventListener('click', function () {
        for (var j = 0; j < selects.length; j++) selects[j].value = '';
        apply();
      });
      apply();
    }

    /* 3. Vorwahl ueber ?bergfuehrer=<kennung>, nur auf der Liste (dort
       gibt es Aufklapper). Auf der Startseite fuehren die Kacheln zur
       Liste, der Parameter wird dort ausgewertet. */
    if (!limit) {
      var param = new URLSearchParams(window.location.search).get('bergfuehrer');
      if (param && /^[a-z0-9-]{3,60}$/i.test(param)) {
        var such = param.toLowerCase();
        var karte = null;
        for (var q = 0; q < karten.length; q++) {
          if ((karten[q].getAttribute('data-bf-kennung') || '').toLowerCase() === such) { karte = karten[q]; break; }
        }
        if (karte) {
          var mehr = karte.querySelector('[data-bf-mehr]');
          if (mehr) mehr.open = true;
          var knopf = karte.querySelector('[data-bf-waehlen]');
          vorwaehlen(knopf ? knopf.getAttribute('data-bf-waehlen') : '', such);
          /* Gemessen am 19.09.2026 im Browser: ein sofortiges scrollIntoView
             blieb bei scrollY 0 (Cookie-Dialog sperrt body mit
             overflow:hidden, Bilder laden lazy). Deshalb verzoegert und
             noch einmal nach load; die Kachel hat dann ihre Hoehe.

             22.09.2026, und das ist der eigentliche Grund: behavior wurde
             nie gesetzt, also galt scroll-behavior:smooth vom html-Element.
             Ein weiches Rollen bricht ab, sobald das naechste anfaengt, und
             hier fangen drei hintereinander an. Gemessen live am
             22.09.2026 auf /pages/bergfuehrer?bergfuehrer=manfred-stuffer
             bei 375 px, ohne Cookie-Dialog im Bild: die Kachel stand 1631
             Pixel unter der Falz, der Aufklapper war offen, das Formular
             war vorgewaehlt, und scrollY blieb 0. Derselbe Aufruf mit
             behavior 'instant' landete auf 1631. Deshalb hart rollen; ein
             Sprung ist hier ohnehin richtiger als eine Fahrt ueber elf
             fremde Gesichter. */
          var hin = function () { if (typeof karte.scrollIntoView === 'function') karte.scrollIntoView({ block: 'start', behavior: 'instant' }); };
          hin();
          setTimeout(hin, 150);
          window.addEventListener('load', function () { setTimeout(hin, 50); });
        }
      }
    }
  }

  /* Knopf "Anfrage schreiben" in einer Kachel: Bergfuehrer vorwaehlen. Der
     Anker selbst scrollt zum Formular, deshalb kein preventDefault. */
  document.addEventListener('click', function (ev) {
    var t = ev.target && ev.target.closest ? ev.target.closest('[data-bf-waehlen]') : null;
    if (!t) return;
    vorwaehlen(t.getAttribute('data-bf-waehlen') || '', '');
  });

  function alle() {
    var roots = document.querySelectorAll('[data-ms-bergfuehrer]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle);
  else alle();
  document.addEventListener('shopify:section:load', alle);
})();
